import ls from './tools/ls.js';

export default {
  namespaced: true,
  state: {
    navigation: false,
    fullscreen: false,
    headerHeight: null,
    mobile: ls.init('mobile', Boolean, false),
    section: ls.init('section', Number, 0),
    dialogs: [],
  },
  mutations: {
    dialog(state, { name, props }) {
      state.dialogs.push({ name, props });
    },
    dialogHide(state, index) {
      if (index !== 'all') {
        state.dialogs.splice(index, 1);
      } else {
        state.dialogs = [];
      }
    },
    mobile(state, mobile) { state.mobile = mobile; },
    headerHeight(state, value) { state.headerHeight = value; },
    fullscreen(state, value) { state.fullscreen = value; },
    navigation(state, input) {
      state.navigation = input;
    },
    section(state, input) {
      state.section = input;
    },
  },
};
